import React from "react";
import GenderIcon from "../../components/reservation/genderIcon";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";

export default function PassengerCellCanceledSpace(props) {

    const { t } = useTranslation();
    const dispatch = useDispatch();

    return (
        <>
            
            {props.space.last_name} {props.space.first_name}
            <br></br>
            <GenderIcon gender={props.space.gender_name} />
            <span className="text_date_format uppercase">{t(props.space.passenger_nationality)}</span>
        </>
    )
}